// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"IW","backgroundimage":"JW","header":"KW","headerwrap":"LW","title":"MW","promomessage":"NW","upsellItem":"OW","upsellImg":"PW","helperText":"QW","upsellHeadline":"RW","price":"SW","upsellGross":"TW","upsellNet":"UW","upsellButton":"VW","nutritionfacts":"WW","nutritionimg":"XW","containerwhy":"YW","nutritionwrappwer":"ZW","headlinewhy":"aX","boxwhy":"bX","textwhy":"cX","backbutton":"eX","drawercontainer":"fX","logoheader":"gX","textwrap":"hX","timer":"iX"};
    if(module.hot) {
      // 1743628930928
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  